//WE.Flow.Html.Contracts.Manifests.GroupMenuFunctionType
export enum GroupMenuFunctionType {
  Config=0,
  Search=1,
  Statistics=2,
  SupportDocuments=3,
  Compilations=4,
  BackgroundJobs=5
}